import addressIcon from "../../../images/landingPage/address_icon.svg";
import closeIcon from "../../../images/landingPage/close_icon.png";
import contactAddressIcon from "../../../images/landingPage/contact_address_icon.svg";
import contactEmailIcon from "../../../images/landingPage/contact_email_icon.svg";
import contactPhoneIcon from "../../../images/landingPage/contact_phone_icon.svg";
import contactSideIcon from "../../../images/landingPage/contact_side_icon.png";
import emailIcon from "../../../images/landingPage/email_icon.svg";
import hamburgerIcon from "../../../images/landingPage/hamburger_icon.png";
import phoneIcon from "../../../images/landingPage/phone_icon.svg";
import successIcon from "../../../images/landingPage/success_icon.svg";
import vmRoutesLogo from "../../../images/landingPage/vm_routes_logo.svg";
import securityIcon1 from "../../../images/landingPage/security.svg";
import httpsIcon from "../../../images/landingPage/https.svg";
import facebookIcon from "../../../images/landingPage/facebook.svg";
import linkedinIcon from "../../../images/landingPage/linkedIn.svg";

import proxy from '../../../build_config'
import proxyConfig from '../../config/reverseProxy';

class Page {
    constructor(globalStore, container) {
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this._init();
    }

    _init = async () => {
        this.ui = await this.makelandingUi();
        this.addEvents(this.ui);
    }

    makelandingUi = async () => {
        this.container.innerHTML = `
    <div class="landing-page-main-container">
    <div class="landing-page-navbar">
        <a href="${proxy.production}/"><img src="${vmRoutesLogo}"></a>
        <img src="${hamburgerIcon}" width="48" height="48" class="hamburger-icon">
        <div class="navbar-link-header">
            <a class="navbar-link navbar-active-link" id="home-nav">Privacy Policy</a>
            <a class="navbar-link contact-us-menu-button" id="contact-nav">Contact Us</a>
            <a class="navbar-link" href="${proxy.production}/client" id="client-nav">Client</a>
            <a class="navbar-link" href="${proxy.production}/vendors" id="vendor-nav">Vendor</a>
            <a class="navbar-link" href="${proxy.production}/operator" id="operator-nav">Operator</a>
        </div>
    </div>

    <hr class="navbar-border">

    <div class="home-page-container" >

        <div class="home-container">
            <div class="home-container significance mt-60">
                <p class="about-text significance" style="
                    color: #212121;
                    text-align: center;
                    font-size: 2.5rem;
                    line-height: 1.5;">
                    <span class="about-text significance highlight">Privacy Policy</span>
                </p>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> respects the privacy of our users and is committed to protecting it through our compliance with this policy. This policy describes the types of information we may collect from you or that you may provide when you use our services and our practices for collecting, using, maintaining, protecting, and disclosing that information.
                </p>
                <br></br>
                <h3 class="about-text highlight">License and Ownership</h3>
                <br></br>
                <p class="about-text">
                    All content on the site is owned by <span class="about-text highlight">
                         VM Routes
                    </span> and is subject to copyright, patent, trademark, and various other intellectual property rights.
                </p>
                <br></br>
                <h3 class="about-text highlight">Disclaimer of Warranties & Limitation of Liability</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> provides the website, Employee App, and Driver App on an &quot;as is&quot; basis without any express or implied warranties. <span class="about-text highlight">
                         VM Routes
                    </span> will not be liable for any damages arising from the use of the site, Employee App, or Driver App.
                </p>
                <br></br>
                <h3 class="about-text highlight">Restrictions</h3>
                <br></br>
                <p class="about-text">
                    You are prohibited from engaging in certain activities that violate these Terms of Use or applicable laws.
                </p>
                <br></br>
                <h3 class="about-text highlight">Termination</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> may terminate your access to the site, Employee App, or Driver App at any time.
                </p>
                <br></br>
                <h3 class="about-text highlight">Information We Collect</h3>
                <br></br>
                <p class="about-text">
                    We collect several types of information from and about users of our services, including information:
                </p>
                <ul class="about-text">
                    <li>Personal information by which you may be identified, such as name, postal address, email address, and telephone number (&quot;personal information&quot;).</li>
                    <li>Information about you that does not individually identify you.</li>
                    <li>Information about your internet connection, the equipment you use to access our services, and usage details.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Employee App</h3>
                <br></br>
                <p class="about-text">
                    For users of the Employee App, we collect:
                </p>
                <ul class="about-text">
                    <li>Name, email address, and contact information.</li>
                    <li>Current location data (for display purposes only, not stored).</li>
                    <li>Usage details automatically as you navigate through the app, information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Driver App</h3>
                <br></br>
                <p class="about-text">
                    For users of the Driver App, we collect:
                </p>
                <ul class="about-text">
                    <li>Name, email address, and contact information.</li>
                    <li>Location data for route tracking and navigation purposes.</li>
                    <li>Camera access for documenting odometer readings and trip Sheet verification (photos are stored securely).</li>
                    <li>Usage details automatically as you navigate through the app, information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">How We Collect Information</h3>
                <br></br>
                <p class="about-text">
                    We collect this information:
                </p>
                <ul class="about-text">
                    <li>Directly from you when you provide it to us.</li>
                    <li>Automatically as you navigate through the site and apps. Information collected automatically may include usage details, IP addresses, and information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">How We Use Your Information</h3>
                <br></br>
                <p class="about-text">
                    We use information that we collect about you or that you provide to us, including any personal information:
                </p>
                <ul class="about-text">
                    <li>To present our services and its contents to you.</li>
                    <li>To provide you with information, products, or services that you request from us.</li>
                    <li>To fulfill any other purpose for which you provide it.</li>
                    <li>For any other purpose with your consent.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Disclosure of Your Information</h3>
                <br></br>
                <p class="about-text">
                    We may disclose aggregated information about our users and information that does not identify any individual without restriction. We may disclose personal information that we collect or you provide as described in this privacy policy:
                </p>
                <ul class="about-text">
                    <li>To our subsidiaries and affiliates.</li>
                    <li>To contractors, service providers, and other third parties we use to support our business.</li>
                    <li>To fulfill the purpose for which you provide it.</li>
                    <li>For any other purpose disclosed by us when you provide the information.</li>
                    <li>With your consent.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Your Rights</h3>
                <br></br>
                <p class="about-text">
                    You have the right to:
                </p>
                <ul class="about-text">
                    <li>Access and receive a copy of the personal information we hold about you.</li>
                    <li>Request correction of the personal information that we hold about you.</li>
                    <li>Request deletion of your personal information.</li>
                    <li>Object to the processing of your personal information.</li>
                    <li>Request the transfer of your personal information to another party.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Data Security</h3>
                <br></br>
                <p class="about-text">
                    We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure.
                </p>
                <br></br>
                <h3 class="about-text highlight">Changes to Our Privacy Policy</h3>
                <br></br>
                <p class="about-text">
                    We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.
                </p>
                <br></br>
                <h3 class="about-text highlight">Contact Information</h3>
                <br></br>
                <p class="about-text">
                    To ask questions or comment about this privacy policy and our privacy practices, contact us at: support@vmtrackers.com.
                </p>
                <br></br>
                <h3 class="about-text highlight">Limitation of Liability</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> will not be liable for any indirect, punitive, or consequential damages.
                </p>
                <br></br>
                <h3 class="about-text highlight">Indemnity</h3>
                <br></br>
                <p class="about-text">
                    You agree to indemnify <span class="about-text highlight">
                         VM Routes
                    </span> against any claims arising from your use of the site, Employee App, Driver App, or violation of these Terms.
                </p>
                <br></br>
                <h3 class="about-text highlight">Dispute Resolution</h3>
                <br></br>
                <p class="about-text">
                    Any dispute will be governed by the Arbitration and Conciliation Act, 1966.
                </p>
                <br></br>
                <h3 class="about-text highlight">Jurisdiction</h3>
                <br></br>
                <p class="about-text">
                    These Terms are governed by the laws of India and are subject to the jurisdiction of the courts in Delhi, India.
                </p>
                <br></br>
                <h3 class="about-text highlight">Severability</h3>
                <br></br>
                <p class="about-text">
                    If any provision of these Terms is found invalid, the remaining provisions will continue to be valid.
                </p>
                <br></br>
                <h3 class="about-text highlight">Complete Agreement</h3>
                <br></br>
                <p class="about-text">
                    These Terms constitute the entire agreement between you and <span class="about-text highlight">
                         VM Routes
                    </span>.
                </p>
                <br></br>
                <h3 class="about-text highlight">Waiver</h3>
                <br></br>
                <p class="about-text">
                    Any failure by <span class="about-text highlight">
                         VM Routes
                    </span> to enforce these Terms does not constitute a waiver of such rights.
                </p>
                <br></br>
                <h3 class="about-text highlight">Disclaimers</h3>
                <br></br>
                <p class="about-text">
                    The services of <span class="about-text highlight">
                         VM Routes
                    </span> are subject to terms and conditions, and the company disclaims any liability for the use of its services.
                </p>
            </div>
        </div>

        <div class="landing-footer-container">
            <div class="landing-footer-details-tab">

                <div class="footer-company-details-tab">
                    <img src="${vmRoutesLogo}">
                    <p class="footer-tab-body"><img src="${addressIcon}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                    <p class="footer-tab-body"><img src="${phoneIcon}"> +91 90921 90321</p>
                    <p class="footer-tab-body"><img src="${emailIcon}"> reachus@virtualmaze.co.in</p>
                </div>
    
                <div class="footer-legal-tab">
                    <p class="footer-tab-title">Legal</p>
                    <p class="footer-tab-body"><a href="${proxy.production}/terms-and-conditions" target="_blank">Terms and Conditions</a></p>
                    <p class="footer-tab-body"><a href="#terms-header-container">Privacy Policy</a></p>
                    <p class="footer-tab-body"><a href="${proxy.production}/cookie-policy" target="_blank">Cookie Policy</a></p>
                </div>
    
                <div class="footer-help-tab">
                    <p class="footer-tab-title">Help</p>
                    <p class="footer-tab-body contact-us-menu-button">Contact Us</p>
                    <div class="footer-icons-container">
                        <a href="https://www.linkedin.com/company/99296180/admin/feed/posts/" target="_blank"><img src="${linkedinIcon}"></a>
                        <a href="https://www.facebook.com/vmroutes" target="_blank"><img src="${facebookIcon}"></a>

                    </div>
                </div>

                <div class="footer-help-tab">
                    <p class="footer-tab-title">Security</p>
                    <div class="footer-icons-container">
                        <img src="${securityIcon1}">
                        <img src="${httpsIcon}">
                    </div>
                </div>

            </div>
            
            <p class="copyright-footer">Copyright © 2024 . VirtualMaze Softsys Private Limited</p>
        </div>

    </div>

    <div class="contact-us-page-container" style="display:none;">
        <div class="contact-us-form-container">
            <div class="contact-form-left-container">
                <p class="contact-form-top-text">Do you have more questions about Agency Portal?</p>
                <p class="contact-form-middle-text"><span>Say Hi!</span> and leave us a message</p>
                <p class="contact-form-bottom-text">Our team will contact you as soon as possible</p>

                <form id="contactForm">
                    <div class="contact-input-container">
                    <label for="fullName">Full Name:</label>
                    <input type="text" id="fullName" name="fullName" placeholder="Ramesh" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="email">Email Address:</label>
                    <input type="email" id="email" name="email" placeholder="ezioauditore@gmail.com" class="contact-input" required>
                    </div>
    
                    <div class="contact-input-container">
                    <label for="phone">Phone Number:</label>
                    <input type="tel" id="phone" name="phone" placeholder="98765 43210" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="subject">Subject:</label>
                    <input type="text" id="subject" name="subject" placeholder="Enquiry on software" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="message">Message:</label>
                    <input type="text" id="message" name="message" placeholder="Write a message" class="contact-input" required>
                    </div>

                    <button class="contact-submit-button">Submit</button>
                </form>
            </div>
            <img src="${contactSideIcon}" class="contact-side-icon">
        </div>

        <div class="contact-information-container">
            <p class="contact-information-title">CONTACT INFORMATION</p>
            <div class="contact-details-container">
                <p class="footer-tab-body"><img src="${contactAddressIcon}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                <p class="footer-tab-body"><img src="${contactEmailIcon}"> reachus@virtualmaze.co.in</p>
                <p class="footer-tab-body"><img src="${contactPhoneIcon}"> +91 90921 90321</p>
            </div>
        </div>

        <iframe style="width: 100%;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15549.788523735537!2d80.19645827526911!3d13.007173759492792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c99154969b%3A0x1892d69b6e39e850!2sVirtualMaze!5e0!3m2!1sen!2sin!4v1702966608642!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    <div class="contact-submit-success-parent-container" style="display: none;">
        <div class="contact-submit-success-inner-container">
            <div class="contact-submit-success-container">
                <img src="${successIcon}" class="contact-success-icon">
                <p class="contact-thank-you-header">Thank you registering with us.</p>
                <p>Your application has been successfully submitted. Our representative will get in touch with you</p>
                <button class="success-ok-button">Ok</button>
            </div>
        </div>
    </div>
    
</div>
    `;
        return this.container;
    }

    addEvents(container) {
        let home = container.querySelector('#home-nav');
        let contactNav = container.querySelector('#contact-nav')
        let contacts = container.querySelectorAll('.contact-us-menu-button');
        home.addEventListener('click', () => {
            container.querySelector('.contact-us-page-container').style.display = "none";
            container.querySelector('.home-page-container').style.display = "block";
            home.classList.add('navbar-active-link');
            contactNav.classList.remove('navbar-active-link');
        })

        contacts.forEach(contact => {
            contact.addEventListener('click', () => {
                container.querySelector('.contact-us-page-container').style.display = "block";
                container.querySelector('.home-page-container').style.display = "none";
                home.classList.remove('navbar-active-link');
                contactNav.classList.add('navbar-active-link');
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
        })

        document.getElementById('contactForm').addEventListener('submit', async function (event) {
            event.preventDefault();

            const formData = {
                name: container.querySelector('#fullName').value,
                email: container.querySelector('#email').value,
                phone: container.querySelector('#phone').value,
                subject: container.querySelector('#subject').value,
                message: container.querySelector('#message').value,
            };

            const url = proxyConfig["proxyUrl"] + `/contactUs`;

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });

                const jsonRes = await response.json();

                if (!jsonRes.success) {
                } else {
                    container.querySelector(".contact-submit-success-parent-container").style.display = 'flex';
                    document.querySelector('.landing-page-main-container').style.overflow = 'hidden';

                    container.querySelector('#fullName').value = ""
                    container.querySelector('#email').value = ""
                    container.querySelector('#phone').value = ""
                    container.querySelector('#subject').value = ""
                    container.querySelector('#message').value = ""
                }
            } catch (err) {
                console.error("Error:", err);
            }
        });

        let success = document.querySelector('.success-ok-button');
        success.addEventListener('click', () => {
            container.querySelector(".contact-submit-success-parent-container").style.display = 'none';
            document.querySelector('.landing-page-main-container').style.overflow = 'unset';
        })


        let hamburger = container.querySelector('.hamburger-icon');
        let navbar = container.querySelector('.navbar-link-header');

        hamburger.addEventListener('click', () => {
            if (hamburger.src.includes(hamburgerIcon)) {
                hamburger.src = closeIcon;
                navbar.classList.add('hamburger-navbar-link-header')
            } else {
                hamburger.src = hamburgerIcon;
                navbar.classList.remove('hamburger-navbar-link-header')
            }
        })

        let navbarLink = container.querySelectorAll('.navbar-link');
        navbarLink.forEach(navabarOne => {
            navabarOne.addEventListener('click', () => {
                navbar.classList.remove('hamburger-navbar-link-header')
                hamburger.src = hamburgerIcon;
            })
        })



    }
}

export default Page;